import React from 'react';

import { MS_IN_S } from '../../constants';
import { useContentRequirementsContext } from '../../features/RestrictNavigation/ContentRequirementsProvider';
import { useTrackingStatus } from '../../features/tracking/components/functional/useTrackingStatus';
import { useItemTracker } from '../../features/tracking/components/hooks/useItemTracker';
import { usePrevious } from '../../hooks/usePrevious';
import { DEFAULT_TIMEOUT_MS } from './constants';
import { ProgressBarStepModel } from './model';
import { ProgressStepComponent } from './ProgressStepComponent';
import { TrackingStatusEnum } from '@ael/core-api';

interface RestrictedProgressStepProps extends ProgressBarStepModel {
  onClick?: () => void;
}

export const RestrictedProgressStep: React.FC<RestrictedProgressStepProps> = ({ id, onClick, disabled, selected }) => {
  const { evaluationResult, isComplete } = useTrackingStatus(id);
  const prevEvaluationResult = usePrevious(evaluationResult);
  const requirements = useContentRequirementsContext();

  const { time, fulfillItemRequirements, fulfilled } = requirements;

  const isRestricted = !requirements.fulfilled && requirements.time > 0;

  useItemTracker(time, fulfillItemRequirements, selected && isRestricted);

  const inProgress =
    (evaluationResult === TrackingStatusEnum.InProgress && !fulfilled) ||
    (evaluationResult === TrackingStatusEnum.NotVisited && selected && (fulfilled || isRestricted)) ||
    (prevEvaluationResult === TrackingStatusEnum.NotVisited && evaluationResult === TrackingStatusEnum.Completed);

  const timeout = time ? time * MS_IN_S : DEFAULT_TIMEOUT_MS;
  const isCompleted = !disabled && isComplete;

  return (
    <ProgressStepComponent
      id={id}
      onClick={onClick}
      disabled={disabled}
      selected={selected}
      inProgress
      style={
        inProgress && !isCompleted
          ? {
              animation: `${timeout}ms progress-animation 0ms`,
            }
          : undefined
      }
    />
  );
};
